import React from "react";
import { DetailItemProps } from "../@types";
import { useTranslate } from "../helpers";

export const DetailItem: React.FunctionComponent<DetailItemProps> = ({
  label,
  detail,
  limitsApply,
  suppressed = false,
}) => {
  const t = useTranslate();
  return (
    <div className="ds-l-row DetailItem">
      <div className="ds-l-col--12 ds-l-lg-col--4 DetailItem__label">
        {label}
      </div>
      <div className="ds-l-col--12 ds-l-lg-col--4 DetailItem__detail">
        {suppressed ? t("suppressed_plan_benefit") : detail}
      </div>
      <div className="ds-l-col--12 ds-l-lg-col--4 DetailItem__detail ds-u-margin-top--1 ds-u-lg-margin-top--0">
        {limitsApply}
      </div>
    </div>
  );
};

export default DetailItem;
